import { SelectInputV2, SelectInputV2Props } from '@frontend/components/basic-forms';
import { EquipmentTriggerName } from '@frontend/equipment/types';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

import useEquipmentTriggerSelect from './equipment-trigger-select.controller';

const ID = 'equipment-trigger-select';
export interface EquipmentTriggerSelectProps extends Omit<SelectInputV2Props<EquipmentTriggerName>, 'options'> {
    subset?: string[];
    dispatch?: ThunkDispatch<any, any, Action>;
}

export const EquipmentTriggerSelect = (props: EquipmentTriggerSelectProps) => {
    const viewProps = useEquipmentTriggerSelect(props);

    return (
        <SelectInputV2<EquipmentTriggerName>
            {...props}
            id={ID + props.id}
            label={props.label || 'Equipment trigger'}
            options={viewProps.options}
        />
    );
};
